<template>
  <charting-box :title="$tc('downloadOpen.title')">
    <chart
      slot="chart"
      slot-scope="{ time }"
      type="bar"
      :height="height"
      :data-url="`/admin/api/magazine/charts/downloads-and-opens?issue_id=${issueId}`"
      :params="time"
      :options="options"
    ></chart>
  </charting-box>
</template>

<script>
import Chart from "@/components/Chart";
import ChartingBox from "@/components/ChartingBox";

export default {
  props: ['issueId','height'],

  components: {
    ChartingBox,
    Chart
  },

  data() {
    return {
      type: "all",
      options: {
        responsive: true,
        maintainAspectRatio: true,
        tooltips: {
          mode: "index",
          intersect: true,
          callbacks: {
            footer: function(tooltipItems, data) {
              var sum0 = 0;
              tooltipItems.forEach(function(tooltipItem) {
                if (data.datasets[tooltipItem.datasetIndex].stack == "s0") {
                  sum0 +=
                    data.datasets[tooltipItem.datasetIndex].data[
                      tooltipItem.index
                    ];
                } else {
                  data.datasets[tooltipItem.datasetIndex].data[
                    tooltipItem.index
                  ];
                }
              });
              return "Total: " + sum0;
            }
          }
        },
        scales: {
          yAxes: [
            {
              stacked: true
            }
          ],
          xAxes: [
            {
              stacked: true
            }
          ]
        },
        plugins: {
          datalabels: {
            display: function(context) {
              return context.dataset.data[context.dataIndex] > 50;
            },
            font: {
              weight: "bold"
            }
          }
        }
      }
    };
  },

  computed: {
    chartDataUrl() {
      if (this.type === "all") {
        return "/admin/api/statistic/downloads-and-reads";
      } else if (this.type === "only-downloads") {
        return "/admin/api/statistic/downloads";
      } else if (this.type === "only-reads") {
        return "/admin/api/statistic/publication-reads";
      } else {
        return "";
      }
    }
  }
};
</script>
